import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';

import { MenuItems } from './menu-items/menu-items';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { ToggleFullscreenDirective } from './fullscreen/toggle-fullscreen.directive';
import {CardRefreshDirective} from './card/card-refresh.directive';
import {CardToggleDirective} from './card/card-toggle.directive';
import { CardComponent } from './card/card.component';
import {ParentRemoveDirective} from './elements/parent-remove.directive';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ModalAnimationComponent} from './modal-animation/modal-animation.component';
import {ModalBasicComponent} from './modal-basic/modal-basic.component';
import {SimpleNotificationsModule} from 'angular2-notifications';
import {TagInputModule} from 'ngx-chips';
import {AnimatorModule} from 'css-animator';
import {ColorPickerModule} from 'ngx-color-picker';
import {CurrencyMaskModule} from 'ng2-currency-mask';
import {SelectModule} from 'ng-select';
import {SelectOptionService} from './elements/select-option.service';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {DataFilterPipe} from './elements/data-filter.pipe';
import {DataTableModule} from 'angular2-datatable';
import {AgmCoreModule} from '@agm/core';
import {UiSwitchModule} from 'ng2-ui-switch/dist';
import {TodoService} from './todo/todo.service';
import {ClickOutsideModule} from 'ng-click-outside';
import {SpinnerComponent} from './spinner/spinner.component';
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {NotificationsService} from 'angular2-notifications';
import {TreeviewModule} from 'ngx-treeview';
import { DateAgoPipe } from './elements/data-ago.pipes';
import { NgxSpinnerModule } from "ngx-spinner";
import { MoveNextByMaxLengthDirective } from './elements/moveNextInput.directive';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      SimpleNotificationsModule.forRoot(),
      TagInputModule,
      UiSwitchModule,
      AnimatorModule,
      ColorPickerModule,
      SelectModule,
      CurrencyMaskModule,
      NgxDatatableModule,
      DataTableModule,
      AgmCoreModule.forRoot({apiKey: 'AIzaSyBSVvQ_zFie5T4sk123456-LF69p7WFdoKUzcAOg'}),
      ClickOutsideModule,
      PerfectScrollbarModule,
      TreeviewModule.forRoot(),
      NgxSpinnerModule
  ],
  declarations: [
      AccordionAnchorDirective,
      AccordionLinkDirective,
      AccordionDirective,
      ToggleFullscreenDirective,
      CardRefreshDirective,
      CardToggleDirective,
      ParentRemoveDirective,
      CardComponent,
      SpinnerComponent,
      ModalAnimationComponent,
      ModalBasicComponent,
      DataFilterPipe,
      DateAgoPipe,
      MoveNextByMaxLengthDirective
  ],
  exports: [
      AccordionAnchorDirective,
      AccordionLinkDirective,
      AccordionDirective,
      ToggleFullscreenDirective,
      CardRefreshDirective,
      CardToggleDirective,
      ParentRemoveDirective,
      CardComponent,
      SpinnerComponent,
      FormsModule,
      NgbModule,
      ReactiveFormsModule,
      ModalBasicComponent,
      ModalAnimationComponent,
      SimpleNotificationsModule,
      TagInputModule,
      UiSwitchModule,
      AnimatorModule,
      ColorPickerModule,
      SelectModule,
      CurrencyMaskModule,
      NgxDatatableModule,
      DataTableModule,
      DataFilterPipe,
      AgmCoreModule,
      ClickOutsideModule,
      PerfectScrollbarModule,
      TreeviewModule,
      DateAgoPipe,
      NgxSpinnerModule,
      MoveNextByMaxLengthDirective
  ],
  providers: [
      MenuItems,
      TodoService,
      SelectOptionService,
      NotificationsService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class SharedModule { }
